export default __webpack_public_path__ + "static/media/online-video.5412f281.svg";